'use client';
import { usePartnerStore } from '@/service/state/Partner/usePartnerStore';

export const CurrencyText = ({ className }: { className?: string }) => {
    const { texts } = usePartnerStore();

    return (
        <p className={className}>
            {texts?.['All prices are in US dollars'] || 'All prices are in US dollars'}
        </p>
    );
};
